import { ShiftState } from "../shiftsSlice";

const payrunSummaryDeleted = (
  state: ShiftState  
) => {
  state.payrunSummary = undefined
};

export default payrunSummaryDeleted;
